import {
	Swiper,
	Navigation,
	Autoplay,
	Pagination,
} from "swiper/js/swiper.esm.js";
import "swiper/css/swiper.min.css";

Swiper.use([Navigation, Autoplay, Pagination]);

const HeaderSlider = function (settings) {
	"use strict";

	const _self = this;
	const _settings = {};

	Object.assign(_settings, settings);

	function initSwiper() {
		_settings.slider = new Swiper(_settings.el, {
			speed: 500,
			loop: true,
			slideToClickedSlide: true,
			autoplay: {
				delay: 6000,
			},
			pagination: {
				el: _settings.pagination,
				bulletClass: _settings.bulletClass,
				currentClass: _settings.currentClass,
				bulletActiveClass: _settings.bulletActiveClass,
				modifierClass: _settings.modifierClass,
				type: "bullets",
				clickable: true,
			},
		});
	}

	function init() {
		initSwiper();

		return _self;
	}

	return init();
};

export { HeaderSlider };
